<template>
  <div class="__SubUserManagement">
    <CTitle large margin-bottom>
      {{ $t('Sub user management') }}

      <template v-slot:subtitle>
        {{ $t('You can add/edit/delete users and set RBAC on the sub user management.') }}
      </template>
    </CTitle>
    <Button :label="$t('Open sub user management')" @click="login" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Button from '@design-system/components/Button.vue';

import CTitle from '@/components/uikit/CTitle';

const messages = {
  en: {
    'Sub user management': 'Sub User Management',
    'Sub user management page': 'Sub user management page',
    'You can add/edit/delete users and set RBAC on the sub user management.':
      'You can add, edit or delete users and apply RBAC permissions.',
    'Open sub user management': 'Open Sub User Management',
  },
  ja: {
    'Sub user management': 'サブユーザーの管理',
    'Sub user management page': 'サブユーザー設定画面',
    'You can add/edit/delete users and set RBAC on the sub user management.':
      'サブユーザー管理画面でユーザーの追加・編集・削除やRBACの設定がおこなうことができます。',
    'Open sub user management': 'サブユーザー管理画面を開く',
  },
};

export default {
  name: 'UserSettings',
  i18n: { messages },
  components: { Button, CTitle },
  methods: {
    ...mapActions('auth', ['loginRbac']),

    async login() {
      try {
        this.loginRbac();
      } catch (e) {
        await this.$alpha.notify.error('access', this.$t('Sub user management page'));
      }
    },
  },
};
</script>
